import * as React from 'react';
const SvgDashboardArrowDown = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, fill: "none" }, props),
    React.createElement("circle", { cx: 7, cy: 7, r: 7, fill: "#7198FF", transform: "matrix(1 0 0 -1 0 14)" }),
    React.createElement("path", { fill: "#fff", d: "M6.137 2.8h1.726v5.165l2.129-2.1L11.2 7.057 7 11.2 2.8 7.057l1.208-1.192 2.129 2.1V2.8Z" })));
export default SvgDashboardArrowDown;
